import { render, staticRenderFns } from "./Massnahme_Durchlass.vue?vue&type=template&id=049d50d4&scoped=true&"
import script from "./Massnahme_Durchlass.vue?vue&type=script&lang=js&"
export * from "./Massnahme_Durchlass.vue?vue&type=script&lang=js&"
import style0 from "./Massnahme_Durchlass.vue?vue&type=style&index=0&id=049d50d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d50d4",
  null
  
)

export default component.exports